import { useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { PRIVATE_ROUTES } from '../../../../routes'
import { getCurrentProjectId } from '../../utils/helpers'
import styles from '../../testrun.module.css'

const PROJECT_TEST_RUN_PATH = new RegExp(
    `^${PRIVATE_ROUTES.projects.root.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/([^/]+)/testrun`
)

export function resolveTestRunProjectId(projectIdProp) {
    if (projectIdProp) return projectIdProp

    if (typeof window !== 'undefined') {
        const match = window.location.pathname.match(PROJECT_TEST_RUN_PATH)
        if (match?.[1]) return match[1]
    }

    return getCurrentProjectId()
}

export function getTestRunCasesPath(projectId) {
    const resolvedProjectId = resolveTestRunProjectId(projectId)
    if (!resolvedProjectId) return PRIVATE_ROUTES.testRun
    return PRIVATE_ROUTES.projects.projectIdView(resolvedProjectId, 'testrun')
}

export function getTestRunReportsPath(projectId) {
    const resolvedProjectId = resolveTestRunProjectId(projectId)
    if (!resolvedProjectId) {
        return `${PRIVATE_ROUTES.testRun}?tab=reports`
    }
    return `${PRIVATE_ROUTES.projects.projectIdView(resolvedProjectId, 'testrun')}?tab=reports`
}

const TestRunTabs = ({
    projectId: projectIdProp,
    activeTab = 'cases',
    reportsCount = null,
    selectionCount = 0,
    reportName = '',
}) => {
    const navigate = useNavigate()
    const location = useLocation()
    const { id: routeId } = useParams()

    const projectId = useMemo(() => {
        if (projectIdProp) return projectIdProp
        const match = location.pathname.match(PROJECT_TEST_RUN_PATH)
        if (match?.[1]) return match[1]
        if (routeId && location.pathname.includes('/projects/')) {
            return routeId
        }
        return getCurrentProjectId()
    }, [projectIdProp, location.pathname, routeId])
    const onDetail = activeTab === 'detail'

    const goCases = () => navigate(getTestRunCasesPath(projectId))
    const goReports = () => navigate(getTestRunReportsPath(projectId))

    return (
        <div className={styles.viewTabsWrap}>
            <div className={styles.viewTabs} role="tablist">
                <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === 'cases'}
                    className={
                        activeTab === 'cases'
                            ? `${styles.viewTab} ${styles.viewTabActive}`
                            : styles.viewTab
                    }
                    onClick={goCases}
                >
                    Test Cases
                    {selectionCount > 0 && (
                        <span className={styles.viewTabBadge}>
                            {selectionCount}
                        </span>
                    )}
                </button>

                <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === 'reports'}
                    className={
                        activeTab === 'reports'
                            ? `${styles.viewTab} ${styles.viewTabActive}`
                            : styles.viewTab
                    }
                    onClick={goReports}
                >
                    Test Reports
                    {reportsCount != null && (
                        <span className={styles.viewTabCount}>
                            {reportsCount}
                        </span>
                    )}
                </button>

                {onDetail && (
                    <span
                        role="tab"
                        aria-selected
                        className={`${styles.viewTab} ${styles.viewTabActive} ${styles.viewTabCurrent}`}
                        title={reportName}
                    >
                        {reportName || 'Report'}
                    </span>
                )}
            </div>
        </div>
    )
}

export default TestRunTabs
